import {Injectable} from "@angular/core";
import {Resolve, ActivatedRouteSnapshot} from "@angular/router";
import {IInstanceModeleFormulaireWebServiceClient, SaveInstanceModeleFormulaireDto} from "@common/resources/resources";

@Injectable()
export class InstanceFormulaireResolver implements Resolve<SaveInstanceModeleFormulaireDto> {

  constructor(private instanceModeleFormulaireWebServiceClient: IInstanceModeleFormulaireWebServiceClient) {

  }

  resolve(route: ActivatedRouteSnapshot) {
    let id = route.params['id'];
    return this.instanceModeleFormulaireWebServiceClient.getInstanceModeleComplete(id);
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-formulaire-demat/digicerba-formulaire-demat-web/src/angular/cerba/src/app/pages/cerba/pages/formulaires/instance-formulaire.resolver.ts